import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';
let SafePipe = /*#__PURE__*/(() => {
  class SafePipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value, type = 'html') {
      switch (type) {
        case 'html':
          return this.sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          throw new Error(`Invalid safe type specified: ${type}`);
      }
    }
    static {
      this.ɵfac = function SafePipe_Factory(t) {
        return new (t || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safe",
        type: SafePipe,
        pure: true,
        standalone: true
      });
    }
  }
  return SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StripHtmlTagsPipe = /*#__PURE__*/(() => {
  class StripHtmlTagsPipe {
    transform(value) {
      if (!value) return value;
      return value
      // Replace <br>, <br/>, <br /> with line breaks
      .replace(/<br\s*\/?>/gi, '\n')
      // Replace <p> and </p> with line breaks
      .replace(/<\/?p\s*\/?>/gi, '\n')
      // Remove all remaining HTML tags
      .replace(/<\/?[^>]+\/?>/g, '')
      // Normalize multiple newlines
      .replace(/\n\s*\n+/g, '\n\n').trim();
    }
    static {
      this.ɵfac = function StripHtmlTagsPipe_Factory(t) {
        return new (t || StripHtmlTagsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "stripHtmlTags",
        type: StripHtmlTagsPipe,
        pure: true,
        standalone: true
      });
    }
  }
  return StripHtmlTagsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StripHtmlPipe = /*#__PURE__*/(() => {
  class StripHtmlPipe {
    transform(value) {
      if (typeof window !== 'undefined') {
        const element = document.createElement('div');
        element.innerHTML = value;
        return element.innerText;
      } else {
        return value;
      }
    }
    static {
      this.ɵfac = function StripHtmlPipe_Factory(t) {
        return new (t || StripHtmlPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "stripHtml",
        type: StripHtmlPipe,
        pure: true,
        standalone: true
      });
    }
  }
  return StripHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TruncatePipe = /*#__PURE__*/(() => {
  class TruncatePipe {
    transform(value, max = 20, stuffix = '...', truncateBy) {
      if (truncateBy !== 'words') {
        return value.length > max ? value.substring(0, max - stuffix.length) + stuffix : value;
      } else {
        return value.split(' ').slice(0, max).join(' ') + stuffix;
      }
    }
    static {
      this.ɵfac = function TruncatePipe_Factory(t) {
        return new (t || TruncatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "truncate",
        type: TruncatePipe,
        pure: true,
        standalone: true
      });
    }
  }
  return TruncatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UrlRewritePipe = /*#__PURE__*/(() => {
  class UrlRewritePipe {
    transform(value, preserveSlash = false) {
      if (typeof value !== 'string') {
        return '';
      }
      var url = value;
      url = url.toLowerCase();
      url = url.replace(/Ç/g, 'c');
      url = url.replace(/ü/g, 'u');
      url = url.replace(/é/g, 'e');
      url = url.replace(/â/g, 'a');
      url = url.replace(/ä/g, 'a');
      url = url.replace(/à/g, 'a');
      url = url.replace(/å/g, 'a');
      url = url.replace(/ç/g, 'c');
      url = url.replace(/ê/g, 'e');
      url = url.replace(/ë/g, 'e');
      url = url.replace(/è/g, 'e');
      url = url.replace(/ï/g, 'i');
      url = url.replace(/î/g, 'i');
      url = url.replace(/ì/g, 'i');
      url = url.replace(/Ä/g, 'a');
      url = url.replace(/Å/g, 'a');
      url = url.replace(/É/g, 'e');
      url = url.replace(/æ/g, 'ae');
      url = url.replace(/Æ/g, 'ae');
      url = url.replace(/ô/g, 'o');
      url = url.replace(/ö/g, 'o');
      url = url.replace(/ò/g, 'o');
      url = url.replace(/û/g, 'u');
      url = url.replace(/ù/g, 'u');
      url = url.replace(/ÿ/g, 'y');
      url = url.replace(/Ö/g, 'o');
      url = url.replace(/Ü/g, 'u');
      url = url.replace(/á/g, 'a');
      url = url.replace(/í/g, 'i');
      url = url.replace(/ó/g, 'o');
      url = url.replace(/ú/g, 'u');
      url = url.replace(/ñ/g, 'n');
      url = url.replace(/Ñ/g, 'n');
      url = url.replace(/\?/g, '');
      url = url.replace(/\./g, '');
      url = url.replace(/!/g, '');
      url = url.replace(/@/g, '');
      url = url.replace(/#/g, '');
      url = url.replace(/\$/g, '');
      url = url.replace(/%/g, '');
      url = url.replace(/\^/g, '');
      url = url.replace(/&/g, '');
      url = url.replace(/\*/g, '');
      url = url.replace(/\(/g, '');
      url = url.replace(/\)/g, '');
      url = url.replace(/</g, '');
      url = url.replace(/>/g, '');
      url = url.replace(/,/g, '');
      url = url.replace(/~/g, '');
      url = url.replace(/`/g, '');
      url = url.replace(/\+/g, '');
      url = url.replace(/=/g, '');
      url = url.replace(/{/g, '');
      url = url.replace(/}/g, '');
      url = url.replace(/\|/g, '');
      url = url.replace(/\[/g, '');
      url = url.replace(/\]/g, '');
      url = url.replace(/\\/g, '');
      url = url.replace(/ /g, '-');
      url = url.replace(/‘/g, '');
      url = url.replace(/’/g, '');
      url = url.replace(/:/g, '');
      url = url.replace(/'/g, '');
      url = url.replace(/"/g, '');
      url = url.replace(/%09/g, '-');
      if (!preserveSlash) {
        url = url.replace(/\//g, '');
      }
      return url;
    }
    static {
      this.ɵfac = function UrlRewritePipe_Factory(t) {
        return new (t || UrlRewritePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "urlRewrite",
        type: UrlRewritePipe,
        pure: true,
        standalone: true
      });
    }
  }
  return UrlRewritePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class StringUtility {
  static StripHTML(value) {
    if (typeof window !== 'undefined') {
      const element = document.createElement('div');
      element.innerHTML = value;
      return element.innerText;
    } else {
      return value;
    }
  }
  static stripHtmlTags(value) {
    if (!value) return value;
    return value
    // Replace <br>, <br/>, <br /> with line breaks
    .replace(/<br\s*\/?>/gi, '\n')
    // Replace <p> and </p> with line breaks
    .replace(/<\/?p\s*\/?>/gi, '\n')
    // Remove all remaining HTML tags
    .replace(/<\/?[^>]+\/?>/g, '')
    // Normalize multiple newlines
    .replace(/\n\s*\n+/g, '\n\n').trim();
  }
  static UrlRewrite(value) {
    if (typeof value !== 'string') {
      return '';
    }
    return value.replace(/ /g, '-').replace(/&/g, 'en').replace(/!/g, '').replace(/\./g, '').replace(/,/g, '').replace(/\?/g, '').replace(/\+/g, '').toLowerCase();
  }
  static Truncate(value, limit = 140, endsWith = '...') {
    return value.length > limit ? value.substring(0, limit - endsWith.length) + endsWith : value;
  }
}
const pipes = [SafePipe, StripHtmlPipe, TruncatePipe, UrlRewritePipe];
let TextUtilityModule = /*#__PURE__*/(() => {
  class TextUtilityModule {
    static {
      this.ɵfac = function TextUtilityModule_Factory(t) {
        return new (t || TextUtilityModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextUtilityModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return TextUtilityModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SafePipe, StringUtility, StripHtmlPipe, StripHtmlTagsPipe, TextUtilityModule, TruncatePipe, UrlRewritePipe };
